import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Badge } from '../../component-badge';
import { forwardRef } from 'react';
/**
 * The `GalleryBadgeListBadge` component is used to display an individual badge in the `GalleryBadgeList`.
 */
export const GalleryBadgeListBadge = forwardRef(({ variant, ...props }, ref) => (_jsx(Badge, { variant: variant, size: "md", ...props, ref: ref })));
GalleryBadgeListBadge.displayName = 'GalleryBadgeListBadge';
